module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  
    var listService = require('ListService.js').default;
    var sales = listService.salesEmailAddress;

    ; __append("\r\n\r\n<div class=\"page-title\">\r\n    <div class=\"row\">\r\n        <div class=\"col col-sm-12 col-lg-12\">\r\n            <h1>REST/SOAP Sources</h1>\r\n        </div>\r\n    </div>\r\n    <div class=\"divider\"></div>\r\n    <div class=\"row workspace\">\r\n\r\n        \r\n        <div class=\"row table\" style=\"display:")
    ; __append(escapeFn(!featureEnabled ? 'none' : 'block' ))
    ; __append(";\">\r\n            \r\n            ")
    ;  
                var maxReached = parseInt(sourcesLimit) === 0 || sourcesLimit <= data.length;
            
    ; __append("\r\n            <div  id=\"newSource\" class=\"row button\" style=\"display:")
    ; __append(escapeFn( maxReached ? 'none' : 'block'))
    ; __append(";\">                \r\n                <button id=\"new-source\"><img src=\"")
    ; __append( require('icon-white.png'))
    ; __append("\"\r\n                        style=\"margin-right: 10px;height: 20px;\" />Create New Source</button>\r\n            </div>\r\n\r\n            <div id=\"maxSourcesReached\" class=\"row\" style=\"font-size: 14px; display:")
    ; __append(escapeFn( maxReached ? 'block' : 'none'))
    ; __append(";\">\r\n                You've reached the maximum number of REST and SOAP service sources allowed for this account. Please contact ")
    ; __append(escapeFn(sales ))
    ; __append(" if you need additional access.\r\n             </div>\r\n          \r\n            <div class=\"row sources-table\">\r\n                <table id=\"sources-table\" class=\"workspace-table\"></table>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"feature-disabled\" style=\"display:")
    ; __append(escapeFn(!featureEnabled ? 'block' : 'none' ))
    ; __append(";\">\r\n            <div class=\"row title\" align=\"center\" style=\"font-size: 1.5vw\">\r\n                Web Service Sources Not Enabled\r\n            </div>\r\n            <div class=\"row title\" align=\"center\" style=\"font-size: 1vw\">\r\n                <div style=\"width:750px\">It looks like you don't have access to Web Service Sources yet. If you're interested in adding this to your account, please contact ")
    ; __append(escapeFn(sales ))
    ; __append(" to learn more.\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n    </div>\r\n</div>\r\n\r\n<div id=\"existingConnectionsModal\" style=\"display: none; font-size: 14px;\">\r\n    This source is linked to the following connections: \r\n    <ul class=\"connection_list\">\r\n        <li>Connection 1</li>\r\n        <li>Connection 2</li>\r\n        <li>Connection 3</li>\r\n    </ul>\r\n    <br/> <div id=\"connModal-content\">Please remove it from those connections or delete the connections before attempting to delete the source.</div>\r\n\r\n</div>\r\n\r\n\r\n")
  }
  return __output;

}